<template>
  <div>
    <section>
      <LandingCarousel/>
    </section> 

    <section id='services'>
      <div
        column
        wrap
        class="my-5"
        align-center
      >
        <div xs12 sm4 class="my-3">
          <DownArrow/>
          <h1>Services</h1>
        </div>
        <v-flex xs12 ref="services">
          <v-container grid-list-xl>
            <v-layout row wrap align-center>
              <v-flex xs12 md4>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                    <MapPin/>
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <div class="headline text-xs-center">Intelligent Mapping</div>
                  </v-card-title>
                  <v-card-text>
                    ThinkSpatial has extensive experience in the production of intelligent, interactive, and cost-effective mapping solutions for deployment on desktops and/or mobile devices, in both online and offline environments. Our intelligent mapping solutions improve productivity, simplify workflows, and are practical and intuitive to use.
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md4>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                    <Satellite/>
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <div class="headline">Surveying Services</div>
                  </v-card-title>
                  <v-card-text>
                    Whether for specific tasks or whole-of-project survey management, our highly qualified professional surveyors have the practical experience and problem-solving abilities to deliver the highest-quality surveying solution for your organisation. ThinkSpatial utilises a range of surveying and data processing technologies such as GNSS Receivers, Network RTK, Robotic Total Stations, and Laser Scanners.
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md4>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                    <Ebee/>
                  </v-card-text>                  
                  <v-card-title primary-title class="layout justify-center">
                    <div class="headline text-xs-center">Unmanned Aerial System</div>
                  </v-card-title>
                  <v-card-text>
                    Traversing the skies at an altitude of 115m ThinkSpatial's eBee provides high resolution aerial imagery (including near-infrared) in a fraction of the time required by conventional methods. ThinkSpatial is a CASA certified operator and we provide a range of services including aerial imagery, digital elevation models, and derived datasets (e.g. NDVI, roads, buildings).
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md6>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                    <Software/>
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <div class="headline text-xs-center">Spatial Software</div>
                  </v-card-title>
                  <v-card-text>
                    ThinkSpatial has a strong track record of designing and developing practical software and systems (for desktop and mobile devices) that solve clients' problems. Our spatial software services range from enterprise-wide management systems (Eye on the Reef, Tangaroa Blue AMDI) through to community engagement tools (Civillo, Sightings Network) and standalone applications for specific purposes (QA4LiDAR, QA4Mobile, MApping Results GEnerator).
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md6>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                    <Inspection/>
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <div class="headline text-xs-center">Asset Capture &amp; Inspection</div>
                  </v-card-title>
                  <v-card-text>
                    ThinkSpatial provides asset capture and inspection services for local governments, management authorities, and private sector organisations throughout Victoria. Over the past few years we have developed an innovative combination of GNSS, consumer mobile devices, and a customised web mapping application to rapidly and accurately capture and inspect your asset base.
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </div>
    </section>
    <section id='clients' >
      <div
        column
        wrap
        class="my-5"
        align-center
      >      
      <div xs12 sm4 class="my-3">
        <DownArrow/>
        <h1>Clients & Projects</h1>
      </div>      
      <Clients/>
      </div>
    </section>
    <section id='contactus' class="contact-footer">
      <ContactUs/>
    </section>
  </div>
</template>

<script>
import LandingCarousel from 'components/LandingCarousel.vue';
import Clients from 'components/Clients.vue';
import ContactUs from 'components/ContactUs.vue';
import Ebee from 'assets/svg/icon_eb.svg';
import Satellite from 'assets/svg/icon_sat.svg';
import MapPin from 'assets/svg/icon_map.svg';
import Software from 'assets/svg/icon_software.svg';
import Inspection from 'assets/svg/icon_inspection.svg';
import DownArrow from 'assets/svg/down_arrow.svg';

export default {
  components: {
    LandingCarousel,
    ContactUs,
    Ebee,
    Satellite,
    MapPin,
    Software,
    Inspection,
    DownArrow,
    Clients
  },
  data() {
    return {    
      queryModel: {
        firstName: null,
        lastName: null,
        email: null,
        company: null,
        phone: null,
        message: null
      },
    }
  },
  methods: {
    scrollMeTo(refName) {
      let element = this.$refs[refName];
      let top = element.offsetTop;
      window.scrollTo(0, top);
    }
  }
}
</script>
<style lang="scss" scoped>
  @import 'assets/landing.scss';  


</style>